export interface VideoFiles {
  original: string;
  compressed: string;
  desktopCompressed?: string;
  squareVideo: string; // name change from square video
}

export class VideoFilesClass implements VideoFiles{
  original: string;
  compressed: string;
  desktopCompressed?: string | undefined;
  squareVideo: string;

  constructor(o:any={}){
    this.original = o['original'] ?? null;
    this.compressed = o['compressed'] ?? null;
    this.desktopCompressed = o['desktopCompressed'] ?? null;
    this.squareVideo = o['squareVideo'] ?? null;
  }
}
